import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useId, useMemo } from 'react';
/**
 * Why writing is closed for the whole app - a firm whose contract ended reads and exports only
 * (ADR-045) - with the id of an element that says so, or `null`. Every button that changes
 * something (`writes`) stays disabled and is described by that reason; the API refuses such
 * writes anyway (`identity.contract-ended`), this is the courtesy.
 */
const WriteLock = createContext(null);
export function WriteLockProvider({ reason, children, }) {
    const id = useId();
    const lock = useMemo(() => (reason === null ? null : { reason, id }), [reason, id]);
    return (_jsxs(WriteLock.Provider, { value: lock, children: [lock && (_jsx("span", { id: id, hidden: true, children: lock.reason })), children] }));
}
/**
 * What the lock does not cover: reading and exporting through a dialog, and what belongs to the
 * person rather than the firm - their own account and devices (ADR-045).
 */
export function OutsideWriteLock({ children }) {
    return _jsx(WriteLock.Provider, { value: null, children: children });
}
/** Why writing is closed here, or `null`. */
export const useWriteLock = () => useContext(WriteLock)?.reason ?? null;
/**
 * What a button that changes something takes while writing is closed: disabled, and described by
 * why - beside what it was described by already.
 */
export function useWriteLockOf(writes, describedBy) {
    const lock = useContext(WriteLock);
    if (!writes || !lock)
        return {};
    return {
        isDisabled: true,
        'aria-describedby': describedBy ? `${describedBy} ${lock.id}` : lock.id,
    };
}
//# sourceMappingURL=write-lock.js.map